import { Controller } from '@hotwired/stimulus';

export default class SedeCurrencyController extends Controller {
    static targets = ['decimalSeparator', 'thousandSeparator', 'decimalPlaces', 'preview'];

    declare readonly decimalSeparatorTarget: HTMLInputElement;
    declare readonly thousandSeparatorTarget: HTMLInputElement;
    declare readonly decimalPlacesTarget: HTMLInputElement;
    declare readonly previewTarget: HTMLElement;
    declare readonly hasPreviewTarget: boolean;

    connect(): void {
        this.updatePreview();
    }

    updatePreview(): void {
        if (!this.hasPreviewTarget) return;

        const decimalSep  = this.decimalSeparatorTarget.value  || '.';
        const thousandSep = this.thousandSeparatorTarget.value || ',';
        const places      = parseInt(this.decimalPlacesTarget.value, 10) || 2;

        const sample  = 1234567.891;
        const [intPart, decPart] = sample.toFixed(Math.max(places, 3)).split('.');

        const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
        const formattedDec = places > 0 ? decimalSep + decPart.slice(0, places) : '';

        this.previewTarget.textContent = formattedInt + formattedDec;
    }
}
